<template>
  <div class="list-title">
    <div class="list-btn">
      <slot></slot>
    </div>
    <div class="title">
      <div>
        <slot name="other"></slot>
      </div>
      <!-- <a-tooltip placement="top" :getPopupContainer="() => $el"  @click.stop="toDocument" style="margin-left: 10px">
        <template slot="title">
          <span>{{$t('common_conj_helpDoc')}}</span>
        </template>
      </a-tooltip> -->
      <div class="documentInfo" v-if="documentInfo && documentInfo.documentId" style="margin-left: 8px" @click.stop="toDocument"
        v-tooltip="{
          content: `<div>${$t('common_conj_helpDoc')}</div>`,
          html: true,
          placement: 'top'
        }"
      >
        <a-icon type="question-circle" style="font-size: 14px;" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  QueryPageBindDocument,
  TransformLogin
} from '@/api/login'

export default {
  props: {
    title: String
  },
  data () {
    return {
      // documentId: null,
      documentInfo: {} // 提示文档信息
    }
  },
  computed: {
    ...mapGetters([
      'meunList',
      'menus'
    ])
  },
  methods: {
    async toDocument () {
      if (this.documentInfo?.platformType === 'OPEN_API_PORTAL') {
        let routeUrl = this.$router.resolve({
          path: '/documentCenter',
          query: { docId: this.documentInfo?.documentId }
        })
        window.open(routeUrl.href, '_blank')
      } else if (this.documentInfo?.platformType === 'SSO_SYS_USER') {
        await TransformLogin({
          targetPlatformCode: 'SSO_SYS_USER'
        }).then(res => {
          window.open(`${process.env.VUE_APP_HOME_URL || '//testnew-home.eccang.com'}/#/company/helper/center?token=${res.data}&docId=${this.documentInfo?.documentId}`, '_blank')
        })
      }
    }
  },
  watch: {
    meunList: {
      handler: function (list) {
        const found = (list || []).find(menu => menu.menuUrl === this.$route.path)
        if (!found) return
        console.log('QueryPageBindDocument')
        QueryPageBindDocument({
          menuId: found.menuId
        }).then(({ data }) => {
          this.documentInfo = data
          if (this.documentInfo?.documentId) {
            this.$emit('done')
          }
          // this.documentId = data.documentId
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.list-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  // margin-right: 24px;
  margin-bottom: 12px;
  .title {
    font-size:16px;
    font-weight:600;
    color:rgba(51,51,51,1);
    padding-left: 15px;
    // border-left: 2px solid #4978D6;
    display: flex;
    align-items: center;
  }
  .list-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .documentInfo {
    width: 30px;
    height: 30px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
  }
  .documentInfo:hover {
  transition: 0.4s;
  border: 1px solid #80b3ff;
  color: #80b3ff;
}
  .other {
    position: absolute;
    right: 40px;
  }
  /deep/ .ant-btn {
    border-radius: 2px;
    font-size: 12px;
  }
  /deep/ .ant-btn-primary {
    background-color: rgba(7, 123, 252, 1);
  }
}
</style>
